// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__2XSqV","header":"MessagesList_header__3446o","chat":"MessagesList_chat__2azxY"};